export default "__VITE_ASSET__DR4U3_fE__"